export const siteConfig = {
  email: (import.meta as any).env?.VITE_CONTACT_EMAIL || 'contact@jeprogroup.com',
  phone: (import.meta as any).env?.VITE_CONTACT_PHONE || '+237 6 99 160 750',
  phoneUnformatted: ((import.meta as any).env?.VITE_CONTACT_PHONE || '+237699160750').replace(/[^0-9]/g, ''),
  address: (import.meta as any).env?.VITE_CONTACT_ADDRESS || 'Douala, Cameroun',
  companyName: (import.meta as any).env?.VITE_COMPANY_NAME || 'JE Pro Group',
  socials: {
    linkedin: (import.meta as any).env?.VITE_SOCIAL_LINKEDIN || 'https://www.linkedin.com/company/j-e-pro-group/',
    facebook: (import.meta as any).env?.VITE_SOCIAL_FACEBOOK || 'https://www.facebook.com/JPGroupConseil',
  },
};